import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import TableContainer from "../TableContainer/TableContainer";
import { Modal, ModalBody } from "reactstrap";
import { FaShieldAlt } from "react-icons/fa";
import { MdSettingsBackupRestore } from "react-icons/md";
import SecurityStatusModal from "./SecurityStatusModal";

import { Box, TablePagination } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { loader, snackbar } from "../../utils";
import {
  getAllSubscriber,
  overrideDevice,
  resetDevice,
} from "../service/admin";
import { Button, IconButton, Tooltip } from "@mui/material";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";

const UsersListing = () => {
  const [data, setData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalData, setTotalData] = useState(0);
  const [securityModalOpen, setSecurityModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const navigate = useNavigate();

  const getEvent = async () => {
    loader.start();
    const eventData = await getAllSubscriber().then((res) => {
      return res.data.data;
    });
    eventData.sort((a, b) => {
      const aDate = new Date(a?.createdAt);
      const bDate = new Date(b?.createdAt);
      return bDate - aDate;
    });

    setAllData(eventData);
    setFilteredData(eventData);
    setTotalData(eventData?.length || 0);
    paginate(eventData, 0);
    loader.stop();
  };

  function filterData(searchValue) {
    setSearchInput(searchValue);
    setPage(0);

    if (!searchValue.trim()) {
      setFilteredData(allData);
      setTotalData(allData?.length || 0);
      paginate(allData, 0);
      return;
    }

    const filtered = allData.filter(
      (res) =>
        (res.name &&
          res.name.toLowerCase().includes(searchValue.toLowerCase())) ||
        (res.mobile_number && res.mobile_number.includes(searchValue)) ||
        (res.deviceId &&
          res.deviceId.toLowerCase().includes(searchValue.toLowerCase())) ||
        (res.deviceId &&
          res.deviceId.toLowerCase().includes(searchValue.toLowerCase())) ||
        (res.requestedDeviceId &&
          res.requestedDeviceId
            .toLowerCase()
            .includes(searchValue.toLowerCase()))
    );

    setFilteredData(filtered);
    setTotalData(filtered?.length || 0);
    paginate(filtered, 0);
  }

  function paginate(dataArray, cpage) {
    const startIndex = cpage * rowsPerPage;
    const slicedData = dataArray.slice(startIndex, startIndex + rowsPerPage);
    setData(slicedData);
  }

  useEffect(() => {
    getEvent();
  }, []);

  useEffect(() => {
    setPage(0);
    paginate(filteredData, 0);
  }, [rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    paginate(filteredData, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleMacSwap = async (subscriberId) => {
    if (!subscriberId) {
      snackbar.error("Subscriber ID is required");
      return;
    }

    const confirmSwap = window.confirm(
      "Are you sure you want to override the device for this subscriber?"
    );

    if (!confirmSwap) return;

    try {
      loader.start();
      const payload = { subscriberId };
      const response = await overrideDevice(payload);

      if (response.data) {
        snackbar.success("MAC Swap successful!");
        getEvent(); // Refresh the list
      }
    } catch (error) {
      console.error("MAC Swap error:", error);
      snackbar.error(
        error.response?.data?.message || "MAC Swap failed. Please try again."
      );
    } finally {
      loader.stop();
    }
  };

  const handleResetDevice = async (mobile) => {
    if (!mobile) {
      snackbar.error("Subscriber ID is required");
      return;
    }

    try {
      loader.start();
      const payload = { mobile };
      const response = await resetDevice(payload);

      if (response.data) {
        snackbar.success("Device reset successful!");
        getEvent(); // Refresh the list
      }
    } catch (error) {
      console.error("Reset device error:", error);
      snackbar.error(
        error.response?.data?.message ||
          "Device reset failed. Please try again."
      );
    } finally {
      loader.stop();
    }
  };

  const handleOpenSecurityModal = (user) => {
    setSelectedUser(user);
    setSecurityModalOpen(true);
  };

  const handleCloseSecurityModal = () => {
    setSecurityModalOpen(false);
    setSelectedUser(null);
  };

  const handleSecurityStatusSuccess = () => {
    getEvent(); // Refresh the list after successful update
  };

  return (
    <>
      <Box>
        <h2 className="fw-600">User Management</h2>
        <div className={`row mt-4`}>
          <div className={`col-lg-5 col-md-6 col-sm-12 col-12`}>
            <input
              type="search"
              placeholder="Search by name, mobile no, or device ID"
              className="form-control w-100"
              value={searchInput}
              onChange={(e) => {
                const value = e.target.value;
                if (value === " ") {
                  filterData("");
                } else {
                  filterData(value);
                }
              }}
            />
          </div>
        </div>
      </Box>

      <div className="mt-4">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Created At</TableCell>
                <TableCell>Phone No.</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>DeviceId</TableCell>
                <TableCell>MAC Swap</TableCell>
                <TableCell>Security Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data?.map((res, index) => {
                return (
                  <TableRow hover key={index}>
                    <TableCell
                      className="pointer text-capitalize"
                      // onClick={() => navigate(`view/${res?.mobile_number}`)}
                    >
                      {res?.name}
                    </TableCell>

                    <TableCell className="text-capitalize">
                      {res?.email ? res?.email : "N/A"}
                    </TableCell>
                    <TableCell className="text-capitalize">
                      {res?.createdAt &&
                        new Date(res.createdAt).toLocaleDateString()}
                    </TableCell>

                    <TableCell>{res?.mobile_number}</TableCell>
                    <TableCell>{res?.Address ? res?.Address : "n/a"}</TableCell>
                    <TableCell>
                      {res?.deviceId ? res?.deviceId : "n/a"}
                    </TableCell>
                    <TableCell sx={{ maxWidth: "130px", padding: "8px 6px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                        }}
                      >
                        <Box>
                          <div
                            style={{
                              fontSize: "0.6rem",
                              color: "#888",
                              marginBottom: "2px",
                            }}
                          >
                            Current:
                          </div>
                          <Box
                            sx={{
                              fontSize: "0.65rem",
                              color: "#555",
                              fontFamily: "monospace",
                              wordBreak: "break-all",
                              lineHeight: "1.3",
                              backgroundColor: "#f9f9f9",
                              padding: "2px 4px",
                              borderRadius: "2px",
                            }}
                          >
                            {res.deviceId || "N/A"}
                          </Box>
                        </Box>
                        {res.requestedDeviceId && (
                          <>
                            <Box>
                              <div
                                style={{
                                  fontSize: "0.6rem",
                                  color: "#1976d2",
                                  marginBottom: "2px",
                                }}
                              >
                                Requested:
                              </div>
                              <Box
                                sx={{
                                  fontSize: "0.65rem",
                                  color: "#1976d2",
                                  fontFamily: "monospace",
                                  wordBreak: "break-all",
                                  lineHeight: "1.3",
                                  backgroundColor: "#e3f2fd",
                                  padding: "2px 4px",
                                  borderRadius: "2px",
                                  border: "1px solid #bbdefb",
                                }}
                              >
                                {res.requestedDeviceId}
                              </Box>
                            </Box>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMacSwap(res?._id);
                              }}
                              sx={{
                                fontSize: "0.65rem",
                                padding: "2px 6px",
                                minHeight: "20px",
                                width: "fit-content",
                                textTransform: "none",
                                fontWeight: 600,
                              }}
                            >
                              Swap
                            </Button>
                          </>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ width: "180px" }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          width: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            width: "100px",
                            padding: "6px 12px",
                            borderRadius: "20px",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            textAlign: "center",
                            backgroundColor:
                              res?.security_status === "Primary"
                                ? "#e3f2fd"
                                : "#fff3e0",
                            color:
                              res?.security_status === "Primary"
                                ? "#1976d2"
                                : "#f57c00",
                            border: `2px solid ${
                              res?.security_status === "Primary"
                                ? "#90caf9"
                                : "#ffb74d"
                            }`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            flexShrink: 0,
                          }}
                        >
                          <FaShieldAlt size={12} />
                          {res?.security_status || "Secondary"}
                        </Box>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => handleOpenSecurityModal(res)}
                          sx={{
                            backgroundColor: "#1976d2",
                            color: "#fff",
                            fontSize: "0.7rem",
                            padding: "5px 12px",
                            width: "60px",
                            textTransform: "none",
                            fontWeight: 600,
                            flexShrink: 0,
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          }}
                        >
                          Update
                        </Button>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <ConfirmModal
                        data={res?.mobile_number}
                        display="device"
                        onsubmit={handleResetDevice}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            color: "#fff",
                            backgroundColor: "#ff5252",
                            "&:hover": {
                              backgroundColor: "#ff5252",
                            },
                            fontSize: "0.75rem",
                            padding: "6px 12px",
                            textTransform: "none",
                            fontWeight: 600,
                          }}
                        >
                          Reset Device
                        </Button>
                      </ConfirmModal>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={totalData}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </div>

      {/* Security Status Modal */}
      {selectedUser && (
        <SecurityStatusModal
          isOpen={securityModalOpen}
          toggle={handleCloseSecurityModal}
          subscriberId={selectedUser._id}
          currentStatus={selectedUser.security_status || "Secondary"}
          onSuccess={handleSecurityStatusSuccess}
        />
      )}
    </>
  );
};

export default UsersListing;
